import { RefObject, useEffect, useState } from "react";

export const useIsVisible = (ref: RefObject<HTMLElement | null>) => {
    const [isIntersecting, setIntersecting] = useState(false);

    useEffect(() => {
        // Create an IntersectionObserver to observe the ref's visibility
        const observer = new IntersectionObserver(([entry]) =>
            setIntersecting(entry.isIntersecting)
        );

        // Start observing the element
        ref.current && observer.observe(ref.current);

        // Cleanup the observer when the component unmounts or ref changes
        return () => {
            observer.disconnect();
        };
    }, [ref]);

    return isIntersecting;
}

export const useIsFullscreen = (ref: RefObject<HTMLElement | null>) => {
    const [isFullscreen, setIsFullscreen] = useState(false);

    const handleChange = () => {
        setIsFullscreen(document.fullscreenElement === ref.current);
    };

    useEffect(() => {
        ref.current?.addEventListener('fullscreenchange', handleChange);
        return (() => {
            ref.current?.removeEventListener('fullscreenchange', handleChange);
        });
    }, [ref]);

    return isFullscreen;
};

export const useIsHovering = (ref: RefObject<HTMLElement | null>) => {

    const [isHovering, setIsHovering] = useState(false);

    const handleIn = () => {
        setIsHovering(true);
     };
    const handleOut = () => {
        setIsHovering(false);
    };

    useEffect(() => {
        ref.current?.addEventListener('mouseenter', handleIn);
        ref.current?.addEventListener('mouseleave', handleOut);

        return(()=>{
            ref.current?.removeEventListener('mouseenter', handleIn);
            ref.current?.removeEventListener('mouseleave', handleOut);
        });
    }, [ref]);

    return isHovering;

};